// Module
var code = "<h2 id=\"credit-reporting\">Credit Reporting</h2> <p>Understand your credit score as well as who and what we report to credit reporting agencies.</p> ";
// Exports
export default code;